import { render, staticRenderFns } from "./item_menu.vue?vue&type=template&id=f3f4d168&scoped=true"
import script from "./item_menu.vue?vue&type=script&lang=js"
export * from "./item_menu.vue?vue&type=script&lang=js"
import style0 from "./item_menu.vue?vue&type=style&index=0&id=f3f4d168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f4d168",
  null
  
)

export default component.exports